<template>
	<div class="hero-section full-bleed">
		<div class="play-wrapper">
			<!-- <img :src="url + item?.field_image?.uri.url" alt="" /> -->
			<div ref="playerRef" :id="'kwik-player-' + id" class="kwik-player trailer"></div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { computed, onMounted, ref, onBeforeUnmount } from "vue"
	import { useUserStore } from "../stores/user"
	import { useI18n } from "vue-i18n"
	import { Movie } from "../types/Movie"
	import { Series } from "../types/Series"
	import { Episode } from "../types/Episode"
	import { url } from "../helper"
	import api from "../composables/useApi"
	const { locale } = useI18n()
	const userStore = useUserStore()
	const playerRef = ref<any>(null)
	const props = defineProps<{
		type: string
		item: Movie | Series | Episode
		id: number
	}>()

	onMounted(async () => {
		const container = document.getElementById(`kwik-player-${props.id}`)
		if (container && !container.hasChildNodes()) {
			// setTimeout(() => {
			// alert(props.item?.field_trailer?.uri)
			// console.log("Initializing Kwik Motion Player...", props.item)
			let videoUrl =
				props.item?.field_trailer_file.data !== null
					? `${url}${props.item?.field_trailer_file.uri.url}`
					: props.item?.field_trailer?.uri
					? props.item?.field_trailer?.uri
					: props.item?.field_trailer
			const res = await api.get("/api/sign-url", {
				params: {
					uuid: props.item?.id,
				},
				headers: {
					Accept: "application/vnd.api+json",
				},
			})
			videoUrl = res.data.signed_url
			const options = {
				autoplay: false,
				muted: true,
				language: locale.value || "el",
				src: videoUrl,
				controls: false,
				loop: true,
				playsinline: true,
				disablePictureInPicture: true,
				poster: props.item?.field_image?.uri.url,
				spatialNavigation: {
					enabled: true,
					horizontalSeek: true,
				},
			}
			const containerId = `kwik-player-${props.id}`
			// Initialize the player
			window.initPlayer(containerId, options, () => {
				const playerInstance = window.kwikMotion(containerId)
				playerInstance.on("ready", () => {
					playerInstance.play()
				})
			})
			// }, 1000)
		}
	})
	onBeforeUnmount(() => {
		const player = window.kwikMotion(`kwik-player-${props.id}`)
		if (player) {
			player.dispose()
		}
	})
</script>

<style lang="scss" scoped>
	video {
		border-radius: 0;
	}
	.hero-section {
		// max-height: 740px;
		// min-height: 500px;
		// overflow: hidden;
		// position: relative;
		z-index: 0;
		height: 56.25vw;

		@include br.respond-to(br.$mobile-xlarge) {
			height: 50vh;
		}

		& > img {
			width: 100%;
			object-fit: cover;
			object-position: center;
			max-height: 740px;
		}
		&::after {
			content: "";
			position: absolute;
			// background: linear-gradient(0deg, var(--dark-gray) 0 75%, transparent);
			background: linear-gradient(0deg, var(--black) 0 30%, transparent);
			bottom: 0;
			left: 0;
			right: 0;
			height: 50%;
			z-index: 0;

			@include br.respond-to(br.$mobile-xlarge) {
				background: linear-gradient(0deg, var(--black) 0 0, transparent);
			}
		}
	}
</style>

<style lang="scss">
	@use "./../scss/general.scss";
	.plyr--full-ui {
		top: 0;
		z-index: 0 !important;
		position: absolute !important;
		width: 100%;
		height: 100% !important;
		left: 0;
		right: 0;
		border: 0px;
	}
	.p-select {
		border-radius: 4px !important;
		border: 1px solid var(--white) !important;
		padding: 5px 20px;
		gap: 15px;
		transition: all 0.3s ease;
		&.p-select-open {
			border-bottom: 0px !important;
			border-radius: 6px 6px 0 0 !important;
		}
	}
	.p-select-label {
		font-size: 22px !important;
		line-height: 1;
	}
	.p-select-list-container {
		border: 1px solid var(--white);
		border-radius: 0 0 6px 6px;
		border-top: 0px;
	}
	.p-select-option {
		padding: 5px 20px !important;
		border-bottom: 1px solid var(--gray) !important;
		background: var(--black) !important;
		&:first-child {
			border-top: 1px solid var(--gray) !important;
		}
		&:last-child {
			border-bottom: 0px;
		}
	}
	.p-select-open {
		svg {
			transform: rotate(180deg);
		}
	}
	.kwik-player.trailer {
		position: absolute;
		top: 0;
		pointer-events: none;
		object-fit: cover;
		height: 740px;
		object-position: center;
		// min-height: 400px;
		padding: 0px;

		@include br.respond-to(br.$mobile-large) {
			height: 100% !important;
		}
	}

	.vjs-poster img {
		object-fit: cover !important;
	}
</style>
